import React from "react";
import { ComponentWithAs, Icon, IconProps } from "@chakra-ui/react";

const IconComp: ComponentWithAs<"svg", IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon {...props}>
      <path d="m15 512h482c8.284 0 15-6.716 15-15v-301c0-4.842-2.371-9.309-6.063-12.047l-84.937-63.003v-44.95c0-8.284-6.716-15-15-15h-64.934l-75.971-57.928c-5.372-4.096-12.818-4.096-18.19 0l-75.971 57.928h-64.934c-8.284 0-15 6.716-15 15v44.95l-84.936 63.003c-3.789 2.803-6.064 7.327-6.064 12.047v301c0 8.284 6.716 15 15 15zm406-353.697 50.875 37.737c-12.139 9.063-30.178 22.532-50.875 37.986zm-165-124.44 35.59 27.137h-71.179zm-135 57.137h270v165.427c-52.61 39.285-111.555 83.308-135 100.838-23.445-17.53-82.39-61.552-135-100.838zm-30 67.303v75.723c-20.697-15.454-38.736-28.923-50.875-37.987zm-61 67.616c57.805 43.16 201.19 150.223 217 162.081 5.333 4 12.667 4 18 0 15.811-11.858 159.195-118.921 217-162.081v256.081h-452z" />
      <path d="m156.997 371.502-69.997 52.498c-6.627 4.971-7.971 14.373-3 21 4.946 6.594 14.341 7.994 21 3l69.997-52.498c6.627-4.971 7.971-14.373 3-21-4.97-6.627-14.372-7.971-21-3z" />
      <path d="m425 424-69.997-52.498c-6.626-4.971-16.03-3.627-21 3-4.971 6.627-3.627 16.029 3 21l69.997 52.498c6.597 4.948 16.008 3.657 21-3 4.971-6.627 3.628-16.029-3-21z" />
      <path d="m196 181h120c8.284 0 15-6.716 15-15s-6.716-15-15-15h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15z" />
      <path d="m331 226c0-8.284-6.716-15-15-15h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15h120c8.284 0 15-6.716 15-15z" />
    </Icon>
  );
};
IconComp.defaultProps = {
  viewBox: "0 0 512 512",
  boxSize: "20px",
};

export default IconComp;
